import { render, staticRenderFns } from "./ProductTreeLevel.vue?vue&type=template&id=bdeb81f2&scoped=true"
import script from "./ProductTreeLevel.vue?vue&type=script&lang=ts"
export * from "./ProductTreeLevel.vue?vue&type=script&lang=ts"
import style0 from "./ProductTreeLevel.vue?vue&type=style&index=0&id=bdeb81f2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb81f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdeb81f2')) {
      api.createRecord('bdeb81f2', component.options)
    } else {
      api.reload('bdeb81f2', component.options)
    }
    module.hot.accept("./ProductTreeLevel.vue?vue&type=template&id=bdeb81f2&scoped=true", function () {
      api.rerender('bdeb81f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductTreeLevel.vue"
export default component.exports